/* Product page helpers: hang the price tag over the gallery, keep [data-la-sync] bits
   (tag price and other Lamp Alley pieces) in step with the selected variant. */
function hangTag() {
  document.querySelectorAll('[data-la-gallery-tag]').forEach((tag) => {
    if (tag._laHung) return;
    const section = tag.closest('.product-information');
    const media = section && section.querySelector('.product-information__media');
    if (!media) return;
    tag._laHung = true;
    media.style.position = media.style.position || 'relative';
    media.appendChild(tag);
    if (window.LampAlley) window.LampAlley.init(media);
  });
}
hangTag();
document.addEventListener('shopify:section:load', hangTag);

document.addEventListener('shopify:product:select', (event) => {
  const p = event.promise;
  if (!p || !p.then) return;
  p.then(({ detail } = {}) => {
    const html = detail && detail.html;
    if (!html || !html.querySelectorAll) return;
    html.querySelectorAll('[data-la-sync]').forEach((fresh) => {
      const key = fresh.getAttribute('data-la-sync');
      document.querySelectorAll(`[data-la-sync="${CSS.escape(key)}"]`).forEach((el) => {
        if (el.innerHTML !== fresh.innerHTML) el.innerHTML = fresh.innerHTML;
      });
    });
  }).catch(() => {});
});
